import React, { useState } from "react";
import "./Recgnsdcomp.css";
import Comming from "../Commingsoon/Comming";
import img1 from "../../assets/images/recn1.png";
import img2 from "../../assets/images/recn2.png";
import img3 from "../../assets/images/recn3.webp";
import img4 from "../../assets/images/recn4.png";

function Recgnsdcomp() {
  return (
    <div className="Recgnsdcomp-conatiner">
      <div className="Recgnsdcomp-content">
        <div className="Recgnsdcomp-txt">
          <p>Recognised and Incubated by</p>
        </div>
        
          <div className="recgn-logos">
            
              <img src={img1} alt="Logo" />
              <img src={img2} alt="Logo" />
           
          
          
            
              <img src={img3} alt="Logo" />
              <img src={img4} alt="Logo" />
            
            
          
        </div>
      </div>
    </div>
  );
}

export default Recgnsdcomp;
